import type { QuickSearchProductResult } from '@/types/searchTypes'
import { useTranslation } from 'react-i18next'
import { ProductImage } from '@/components/ProductImage/ProductImage'
import { getQuickSearchResultLabel } from '@/components/QuickSearch/quickSearchLabels'
import { HighlightMatch } from './HighlightMatch'

interface SearchCardProps {
  query: string
  result: QuickSearchProductResult
  onClick: () => void
}

export function SearchCard({ query, result, onClick }: Readonly<SearchCardProps>) {
  const { i18n } = useTranslation()
  const label = getQuickSearchResultLabel(result.labels, i18n.language)

  return (
    <button
      type="button"
      className="quick-search__card"
      onClick={onClick}
    >
      <ProductImage
        checkAvailability
        image={result.image}
        imageClassName="quick-search__card-image"
        placeholderClassName="quick-search__card-image quick-search__card-image-placeholder"
        placeholderIconSize={24}
        placeholderTestId={`quick-search-image-placeholder_${result.id}`}
        width={250}
      />
      <span className="quick-search__card-code">{result.code}</span>
      <span className="quick-search__card-title">
        <HighlightMatch text={label} query={query} />
      </span>
    </button>
  )
}
